import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderInfo from '../../../../Components/Common/HeaderInfo';
import messages from '../../../../assets/Messages.json';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showLoading } from 'react-global-loading';
import Remarks from './Remarks';
import Remarks__list from './Remarks__list';
import { markPageAsSaved, PAGE_NAMES, refreshBalanceSheetValidation } from '../../../../Components/BalanceSheet/BalanceSheetHeader';
import { filterRemarksList } from '../../../../Custom/Custom';

function EmploymentAndLabourCost() {
  const navigate = useNavigate();

  const [headerData, setHeaderData] = useState({
    despatchSlNo: '',
    permanentSlNo: '',
    companyName: '',
    surveyYear: ''
  });

  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({});
  const [labourWagesData, setLabourWagesData] = useState([]);
  const [footerData, setFooterData] = useState({
    averageNoOfPersonsWorked: 0,
    salaryAndWagesFromPLAccount: '',
    esiPfFromPLAccount: '',
    bonusFromPLAccount: '',
    socialWelfareExpensesFromPLAccount: ''
  });

  const [totalProfitandLossAmount, setTotalProfitandLossAmount] = useState({
    SL_No: '',
    Description: '',
    Amount: ''
  });

  const [remarksData, setRemarksData] = useState({
    remarksBlock: 'ALL',
    remarksItems: '',
    remarks: ''
  });

  const [remarksList, setRemarksList] = useState([]);

  // Authentication configuration
  const getAuthConfig = () => {
    let token = localStorage.getItem('jwt');
    
    if (!token) {
      token = localStorage.getItem('token') || 
              localStorage.getItem('authToken') || 
              localStorage.getItem('accessToken') ||
              localStorage.getItem('userToken');
    }
    
    if (!token) {
      console.error('No authentication token found');
      toast.error('Authentication token not found. Please login again.', messages.COLOR_RED);
      return {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };
    }
    
    const cleanToken = token.replace(/['"]/g, '').trim();
    
    return {
      headers: {
        'Authorization': `Bearer ${cleanToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  };

  useEffect(() => {
    const fetchHeaderData = () => {
      try {
        const balanceSheetData = localStorage.getItem('balanceSheetFormData');

        if (balanceSheetData) {
          const parsedData = JSON.parse(balanceSheetData);

          setHeaderData({
            despatchSlNo: parsedData.dslNo || '',
            permanentSlNo: parsedData.pslNo || '',
            companyName: parsedData.nameUnit || '',
            surveyYear: parsedData.year || ''
          });
        } else {
          // If no data in localStorage, set defaults
          console.log('No balanceSheet data found in localStorage');
          setHeaderData({
            despatchSlNo: 'DSL No. not set',
            permanentSlNo: 'PSL No. not set',
            companyName: 'Company name not set',
            surveyYear: ''
          });
        }
      } catch (error) {
        console.error('Error fetching data from localStorage:', error);
        setHeaderData({
          despatchSlNo: 'Error loading data',
          permanentSlNo: 'Error loading data',
          companyName: 'Error loading data',
          surveyYear: ''
        });
      }
    };

    fetchHeaderData();
  }, []);


  // Load existing data from API
  const loadExistingData = async () => {
    if (!headerData.despatchSlNo || headerData.despatchSlNo === 'DSL No. not set' || !headerData.surveyYear) {
      return;
    }

    setIsLoading(true);
    showLoading(true);

    try {
      const payload = {
        dsl_no: headerData.despatchSlNo,
        survey_year: headerData.surveyYear.split('-')[0] 
      };

      console.log('Loading labour wages data with payload:', payload);
      const response = await axios.post(`${API_URL}api/blockE/getLabourWagesDataForm`, payload, getAuthConfig());
      console.log('Labour wages API Response:', response.data);

      if (response.data && response.data.status && response.data.data) {
        const apiData = response.data.data;
        
        // Map labourWagesData array by matching catagoryId
        if (apiData.labourWagesData && Array.isArray(apiData.labourWagesData)) {
          // Create a map of catagoryId to data for quick lookup
          const dataByCategory = {};
          apiData.labourWagesData.forEach(item => {
            const catId = item.catagoryId || item.catagory_id || item.categoryId || item.category_id;
            if (catId) {
              dataByCategory[catId] = item;
            }
          });
          
          // Map data by matching catagoryId - preserve original structure and update only matching fields
          const mappedData = apiData.labourWagesData.map(item => {
            const catId = item.catagoryId || item.catagory_id || item.categoryId || item.category_id;
            const matchedData = dataByCategory[catId] || {};
            
            return {
              catagoryId: catId || '',
              categoryOfStaff: matchedData.categoryOfStaff || matchedData.category_of_staff || item.categoryOfStaff || item.category_of_staff || '',
              dslNo: matchedData.dslNo || matchedData.dsl_no || item.dslNo || item.dsl_no || '',
              surveyYear: matchedData.surveyYear || matchedData.survey_year || item.surveyYear || item.survey_year || '',
              manufacturing: (matchedData.manufacturing !== undefined && matchedData.manufacturing !== null && matchedData.manufacturing !== '') 
                            ? matchedData.manufacturing.toString() : '',
              nonmanufacturing: (matchedData.nonmanufacturing !== undefined && matchedData.nonmanufacturing !== null && matchedData.nonmanufacturing !== '')
                               ? matchedData.nonmanufacturing.toString() : '',
              total: (matchedData.total !== undefined && matchedData.total !== null && matchedData.total !== '') 
                    ? matchedData.total.toString() : '',
              avgNoPersonsWorked: (matchedData.avgNoPersonsWorked !== undefined && matchedData.avgNoPersonsWorked !== null && matchedData.avgNoPersonsWorked !== '')
                                 ? matchedData.avgNoPersonsWorked.toString() 
                                 : ((matchedData.avg_no_persons_worked !== undefined && matchedData.avg_no_persons_worked !== null && matchedData.avg_no_persons_worked !== '')
                                   ? matchedData.avg_no_persons_worked.toString() : ''),
              noMandaysPaid: (matchedData.noMandaysPaid !== undefined && matchedData.noMandaysPaid !== null && matchedData.noMandaysPaid !== '')
                            ? matchedData.noMandaysPaid.toString()
                            : ((matchedData.no_mandays_paid !== undefined && matchedData.no_mandays_paid !== null && matchedData.no_mandays_paid !== '')
                              ? matchedData.no_mandays_paid.toString() : ''),
              wagesOrSalaries: (matchedData.wagesOrSalaries !== undefined && matchedData.wagesOrSalaries !== null && matchedData.wagesOrSalaries !== '')
                              ? matchedData.wagesOrSalaries.toString()
                              : ((matchedData.wages_or_salaries !== undefined && matchedData.wages_or_salaries !== null && matchedData.wages_or_salaries !== '')
                                ? matchedData.wages_or_salaries.toString() : ''),
              statusFlag: matchedData.statusFlag || matchedData.status_flag || item.statusFlag || item.status_flag || ''
            };
          });
          
          setLabourWagesData(mappedData);
          setFormData(mappedData);
        }

        // Map API response to Remarks List from remarks array
        let mappedRemarksList = [];
        if (apiData.remarks && Array.isArray(apiData.remarks)) {
          mappedRemarksList = apiData.remarks.map((remark, index) => {
            // Extract block letter from "BLOCK X" format (e.g., "BLOCK X" -> "X")
            let blockLetter = '';
            if (remark.block) {
              // Remove "BLOCK " prefix and get the letter
              blockLetter = remark.block.replace(/^BLOCK\s+/i, '').trim();
            }
            
            return {
              slNo: index + 1,
              blocks: blockLetter || remark.block || '',
              columns: remark.columnsName || '',
              items: remark.items || remark.Items || '',
              remarks: remark.remarks || '',
              remarksCreatedOn: remark.createdDate || remark.createdTime || '',
              remarksBy: remark.updatedBy || '',
              role: remark.updatedBy || ''
            };
          });
          setRemarksList(mappedRemarksList);
        } else {
          // Fallback: if remarks array is not available, use empty array
          setRemarksList([]);
        }
        
        // Set default in Items dropdown based on remarksList availability
        // If remarksList is empty, set "SELECT_REMARKS", otherwise set "ALL"
        setRemarksData({
          remarksBlock: (mappedRemarksList.length > 0) ? 'ALL' : 'SELECT_REMARKS',
          remarksItems: '',
          remarks: ''
        });

        // Map totalProfitandLossAmount from API response
        if (apiData.totalProfitandLossAmount) {
          setTotalProfitandLossAmount({
            SL_No: apiData.totalProfitandLossAmount.SL_No || apiData.totalProfitandLossAmount.sl_No || '',
            Description: apiData.totalProfitandLossAmount.Description || apiData.totalProfitandLossAmount.description || '',
            Amount: apiData.totalProfitandLossAmount.Amount || apiData.totalProfitandLossAmount.amount || ''
          });
        } else {
          // Reset to empty if not available
          setTotalProfitandLossAmount({
            SL_No: '',
            Description: '',
            Amount: ''
          });
        }
      }
    } catch (error) {
      console.error('Error loading labour wages data:', error);
      if (error.response?.status === 401) {
        toast.error('Session expired. Please login again.', messages.COLOR_RED);
      } else if (error.response?.status === 403) {
        toast.error('Access denied. Please check your permissions.', messages.COLOR_RED);
      } else if (error.response?.status === 404) {
        console.log('No existing labour wages data found');
      } else {
        toast.error('Error loading data. Please try again.', messages.COLOR_RED);
      }
    } finally {
      setIsLoading(false);
      showLoading(false);
    }
  };

  // Map API data to form inputs
  const mapApiDataToForm = (apiData) => {
    const newTableData = {};
    const newFooterData = {
      averageNoOfPersonsWorked: 0,
      salaryAndWagesFromPLAccount: '',
      esiPfFromPLAccount: '',
      bonusFromPLAccount: '',
      socialWelfareExpensesFromPLAccount: ''
    };



    // Map footer data from first item (assuming all items have same footer data)
    if (apiData.length > 0) {
      const firstItem = apiData[0];
      newFooterData.averageNoOfPersonsWorked = firstItem.average_no_of_persons_worked_unpaid_family_member || 0;
      newFooterData.salaryAndWagesFromPLAccount = firstItem.salary_and_wages_from_pl_account?.toString() || '';
      newFooterData.esiPfFromPLAccount = firstItem.esi_pf_from_pl_account?.toString() || '';
      newFooterData.bonusFromPLAccount = firstItem.bonus_from_pl_account?.toString() || '';
      newFooterData.socialWelfareExpensesFromPLAccount = firstItem.social_welfare_expenses_from_pl_account?.toString() || '';
    }

    console.log('Mapped table data:', newTableData);
    console.log('Mapped footer data:', newFooterData);
    
    setTableData(newTableData);
    setFooterData(newFooterData);
  };

  // Load data when component mounts and header data is available
  useEffect(() => {
    if (headerData.despatchSlNo && headerData.despatchSlNo !== 'DSL No. not set' && headerData.surveyYear) {
      loadExistingData();
    }
  }, [headerData.despatchSlNo, headerData.surveyYear]);

  // When API data is ready, map to table
  useEffect(() => {
    if (formData && formData.length > 0) {
      mapApiDataToForm(formData);
    }
  }, [formData]);

  // Calculate avgNoPersonsWorked based on Total / Number of working days
  // Formula: avgNoPersonsWorked = Total (Column 5) / Number of working days [(iii) Total (i+ii)]
  // Note: This function only triggers re-render, actual calculation is done in render
  const calculateAvgNoPersonsWorked = () => {
    // Just trigger a re-render by updating state
    // The actual calculation happens in the render function
    setLabourWagesData(prevData => [...prevData]);
  };

  // Handle input changes for table data with validation
  const handleTableInputChange = (rowIndex, fieldName, value) => {
    // Apply numeric validation for all numeric fields
    let validatedValue = value;
    
    // Allow empty string, numbers, and decimal points
    if (value === '' || value === '0' || /^\d*\.?\d*$/.test(value)) {
      // Limit to 2 decimal places
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length > 2) {
          validatedValue = parts[0] + '.' + parts[1].substring(0, 2);
        }
      }
      
      // Limit total length to 15 characters (including decimal point)
      if (validatedValue.length > 15) {
        validatedValue = validatedValue.substring(0, 15);
      }
    } else {
      // If invalid characters, keep previous value
      return;
    }

    // Update the labourWagesData state
    setLabourWagesData(prevData => {
      const newData = [...prevData];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [fieldName]: validatedValue
      };
      return newData;
    });
  };
  
  // Handle onBlur for wagesOrSalaries to trigger avgNoPersonsWorked calculation
  const handleWagesOrSalariesBlur = (rowIndex, item) => {
    // If this is (i) Manufacturing days or (ii) Non-manufacturing days, recalculate avgNoPersonsWorked
    if (item.categoryOfStaff?.includes('(i) Manufacturing') || 
        item.categoryOfStaff?.includes('(ii) Non-manufacturing')) {
      // Small delay to ensure state is updated
      setTimeout(() => {
        calculateAvgNoPersonsWorked();
      }, 100);
    }
  };

  // Handle footer input changes with validation
  const handleFooterInputChange = (field, value) => {
    // Apply numeric validation for footer fields
    let validatedValue = value;
    
    // Allow empty string, numbers, and decimal points
    if (value === '' || value === '0' || /^\d*\.?\d*$/.test(value)) {
      // Limit to 2 decimal places
      if (value.includes('.')) {
        const parts = value.split('.');
        if (parts[1] && parts[1].length > 2) {
          validatedValue = parts[0] + '.' + parts[1].substring(0, 2);
        }
      }
      
      // Limit total length to 15 characters (including decimal point)
      if (validatedValue.length > 15) {
        validatedValue = validatedValue.substring(0, 15);
      }
    } else {
      // If invalid characters, keep previous value
      return;
    }

    setFooterData(prev => ({
      ...prev,
      [field]: validatedValue
    }));
  };

  // Prepare data for API submission
  const prepareSubmissionData = () => {
    const surveyYearValue = headerData.surveyYear ? headerData.surveyYear.split('-')[0] : '';
    
    // Find Part B index
    const partBIndex = labourWagesData.findIndex(item => 
      item.categoryOfStaff?.includes('Part B:')
    );
    
    // Get Part A data (excluding headers) for auto-calculations
    const partAData = labourWagesData.filter((item, idx) => {
      if (partBIndex > 0 && idx >= partBIndex) return false;
      if (item.categoryOfStaff?.includes('Part A:')) return false;
      return true;
    });
    
    // Helper function to sum values for specific rows in Part A
    const sumPartARows = (indices, field) => {
      let sum = 0;
      indices.forEach(idx => {
        if (partAData[idx]) {
          sum += parseFloat(partAData[idx][field]) || 0;
        }
      });
      return sum > 0 ? sum : '';
    };
    
    // Find indices for Part B special rows
    const manufacturingDaysIndex = labourWagesData.findIndex(item => 
      item.categoryOfStaff?.includes('(i) Manufacturing')
    );
    const nonManufacturingDaysIndex = labourWagesData.findIndex(item => 
      item.categoryOfStaff?.includes('(ii) Non-manufacturing')
    );
    
    // Prepare data array from labourWagesData - send ALL rows with all keys (including Part A and Part B headers)
    const dataArray = labourWagesData.map((item, index) => {
      // Check row type for auto-calculations
      const isSubTotal = item.categoryOfStaff?.includes('Sub-Total');
      const isTotalWorkers = item.categoryOfStaff?.includes('Total Workers');
      const isTotalEmployees = item.categoryOfStaff?.includes('Total employees');
      const isTotalWorkingDays = item.categoryOfStaff?.includes('(iii) Total');
      const isAutoCalcRow = isSubTotal || isTotalWorkers || isTotalEmployees;
      
      // Get auto-calculated values for sum rows
      const getAutoValue = (field) => {
        if (isSubTotal) {
          // Sub-Total = Row 1 + Row 2 + Row 3 (indices 0, 1, 2 in partAData)
          return sumPartARows([0, 1, 2], field);
        } else if (isTotalWorkers) {
          // Total Workers (items 4+5) = items 1+2+3 + item 5
          return sumPartARows([0, 1, 2, 4], field);
        } else if (isTotalEmployees) {
          // Total employees (items 6+7+8+9) = Total Workers + items 7+8+9
          return sumPartARows([0, 1, 2, 4, 6, 7, 8], field);
        }
        return item[field] !== '' && item[field] !== undefined ? parseFloat(item[field]) : '';
      };
      
      // Get manufacturing and nonmanufacturing values (with auto-calc for sum rows)
      const mfgValue = isAutoCalcRow ? getAutoValue('manufacturing') : 
                       (item.manufacturing !== '' && item.manufacturing !== undefined ? parseFloat(item.manufacturing) : '');
      const nonMfgValue = isAutoCalcRow ? getAutoValue('nonmanufacturing') : 
                         (item.nonmanufacturing !== '' && item.nonmanufacturing !== undefined ? parseFloat(item.nonmanufacturing) : '');
      
      // Auto-calculate total (Column 5 = Column 3 + Column 4)
      let calculatedTotal = '';
      const mfg = typeof mfgValue === 'number' ? mfgValue : 0;
      const nonMfg = typeof nonMfgValue === 'number' ? nonMfgValue : 0;
      if (mfg > 0 || nonMfg > 0) {
        calculatedTotal = mfg + nonMfg;
      }
      
      // Get wages/salaries value - for Part B (iii) Total row, calculate sum of (i) + (ii)
      let wagesValue = '';
      if (isTotalWorkingDays) {
        // (iii) Total = (i) Manufacturing days + (ii) Non-manufacturing days
        const mfgDays = manufacturingDaysIndex >= 0 ? 
                       (parseFloat(labourWagesData[manufacturingDaysIndex]?.wagesOrSalaries) || 0) : 0;
        const nonMfgDays = nonManufacturingDaysIndex >= 0 ? 
                          (parseFloat(labourWagesData[nonManufacturingDaysIndex]?.wagesOrSalaries) || 0) : 0;
        wagesValue = (mfgDays > 0 || nonMfgDays > 0) ? (mfgDays + nonMfgDays) : '';
      } else if (isAutoCalcRow) {
        wagesValue = getAutoValue('wagesOrSalaries');
      } else {
        wagesValue = item.wagesOrSalaries !== '' && item.wagesOrSalaries !== undefined ? parseFloat(item.wagesOrSalaries) : '';
      }
      
      // Calculate avgNoPersonsWorked = Total / Number of working days
      // Find total working days from (iii) Total (i+ii)
      const mfgDaysItem = labourWagesData.find(i => i.categoryOfStaff?.includes('(i) Manufacturing'));
      const nonMfgDaysItem = labourWagesData.find(i => i.categoryOfStaff?.includes('(ii) Non-manufacturing'));
      const totalWorkingDays = (parseFloat(mfgDaysItem?.wagesOrSalaries) || 0) + (parseFloat(nonMfgDaysItem?.wagesOrSalaries) || 0);
      
      let avgPersonsWorked = '';
      if (isAutoCalcRow) {
        avgPersonsWorked = getAutoValue('avgNoPersonsWorked');
      } else if (totalWorkingDays > 0 && calculatedTotal > 0) {
        // Auto-calculate: Total / Number of working days
        avgPersonsWorked = Math.round(calculatedTotal / totalWorkingDays);
      } else {
        avgPersonsWorked = item.avgNoPersonsWorked !== '' && item.avgNoPersonsWorked !== undefined ? parseFloat(item.avgNoPersonsWorked) : '';
      }
      
      return {
        dsl_no: headerData.despatchSlNo || '',
        survey_year: surveyYearValue || '',
        catagory_id: item.catagoryId || '',
        category_of_staff: item.categoryOfStaff || '',
        manufacturing: mfgValue,
        nonmanufacturing: nonMfgValue,
        total: calculatedTotal,
        avg_no_persons_worked: avgPersonsWorked,
        no_mandays_paid: isAutoCalcRow ? getAutoValue('noMandaysPaid') : 
                        (item.noMandaysPaid !== '' && item.noMandaysPaid !== undefined ? parseFloat(item.noMandaysPaid) : ''),
        wages_or_salaries: wagesValue
      };
    });

    // Prepare remarks array
    const remarksArray = [];
    if (remarksData.remarks && remarksData.remarks.trim() !== '') {
      // Get the selected item name from remarksBlock
      let itemName = remarksData.remarksBlock;
      if (itemName === 'ALL' || itemName === 'SELECT_REMARKS') {
        itemName = ''; // Don't send ALL/SELECT_REMARKS as item name
      }
      
      remarksArray.push({
        dslNo: parseInt(headerData.despatchSlNo) || headerData.despatchSlNo,
        surveyYear: parseInt(surveyYearValue) || surveyYearValue,
        block: 'E',
        columnsName: remarksData.remarksItems || '',
        Items: itemName,
        remarks: remarksData.remarks
      });
    }

    return {
      data: dataArray,
      remarks: remarksArray
    };
  };

  // Submit data to API
  const handleSave = async () => {
    if (!headerData.despatchSlNo || headerData.despatchSlNo === 'DSL No. not set') {
      toast.error('Please ensure DSL No. is available', messages.COLOR_RED);
      return false;
    }

    if (!headerData.surveyYear) {
      toast.error('Please ensure Survey Year is available', messages.COLOR_RED);
      return false;
    }

    setIsLoading(true);
    showLoading(true);

    try {
      const payload = prepareSubmissionData();
      console.log('Submitting labour wages data:', payload);

      // Check if labourWagesData is loaded
      if (payload.data.length === 0) {
        toast.error('No data available. Please wait for data to load.', messages.COLOR_RED);
        return false;
      }

      const response = await axios.post(`${API_URL}api/blockE/insert-bulk`, payload, getAuthConfig());
      console.log('Labour wages API Response:', response.data);

      if (response.data && response.data.status) {
        toast.success(response.data.message || 'Data saved successfully!', messages.COLOR_RED);
        // Data will remain as is after save (no reset)
        
        // Mark page as saved for green header
        markPageAsSaved(PAGE_NAMES.EMPLOYMENT_LABOUR_COST);
        // Refresh balance sheet validation to update header colors
        if (headerData.despatchSlNo && headerData.surveyYear) {
          await refreshBalanceSheetValidation(headerData.despatchSlNo, headerData.surveyYear);
        }
        
        return true;
      } else {
        toast.error(response.data?.message || 'Failed to save data', messages.COLOR_RED);
        return false;
      }
    } catch (error) {
      console.error('Error saving labour wages data:', error);
      if (error.response?.status === 401) {
        toast.error('Session expired. Please login again.', messages.COLOR_RED);
      } else if (error.response?.status === 403) {
        toast.error('Access denied. Please check your permissions.', messages.COLOR_RED);
      } else {
        toast.error(error.response?.data?.message || 'Error saving data. Please try again.', messages.COLOR_RED);
      }
      return false;
    } finally {
      setIsLoading(false);
      showLoading(false);
    }
  };

  // Reset form data
  const handleReset = () => {
    setTableData({});
    // Reset labourWagesData by clearing all input values but keeping structure
    setLabourWagesData(prevData => 
      prevData.map(item => ({
        ...item,
        manufacturing: '',
        nonmanufacturing: '',
        total: '',
        avgNoPersonsWorked: '',
        noMandaysPaid: '',
        wagesOrSalaries: ''
      }))
    );
    setFooterData({
      averageNoOfPersonsWorked: 0,
      salaryAndWagesFromPLAccount: '',
      esiPfFromPLAccount: '',
      bonusFromPLAccount: '',
      socialWelfareExpensesFromPLAccount: ''
    });
  };

  // Filter remarks list using centralized function from Custom.js
  const filteredRemarksList = useMemo(() => {
    return filterRemarksList(remarksList, remarksData);
  }, [remarksList, remarksData]);

  // Memoized items for dropdown - shows all items from Part A and Part B (Item 1 to 15)
  const dropdownItemsData = useMemo(() => {
    const allItems = [];
    const itemNames = [];
    let itemNumber = 0;
    
    labourWagesData.forEach((item, idx) => {
      // Skip header rows
      if (item.categoryOfStaff?.includes('Part A:') || 
          item.categoryOfStaff?.includes('Part B:') ||
          item.categoryOfStaff?.includes('Number of working days')) {
        return;
      }
      
      itemNumber++;
      const itemName = `Item ${itemNumber} - ${item.categoryOfStaff || ''}`;
      
      // For filteredBlockItems format (item_name property)
      allItems.push({
        item_code: item.catagoryId,
        item_name: itemName
      });
      
      // For selectedItemsFromTable format (just strings)
      itemNames.push(itemName);
    });
    
    return { allItems, itemNames };
  }, [labourWagesData]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      <div className="container-fluid py-3">
        {/* Header Section - Using HeaderInfo Component exactly like BalanceSheetData */}
        <HeaderInfo
          title="EMPLOYMENT AND LABOUR COST (Working Sheet)"
          icon="fa fa-users"
          iconColor="#1976d2"
          titleColor="#1976d2"
          backgroundColor=""
          dispatchSlNo={headerData.despatchSlNo}
          permanentSlNo={headerData.permanentSlNo}
          companyName={headerData.companyName}
          companyPlaceholder="Enter Company Name"
          showBlockCType={false} // Employment page doesn't need Block C Type
          includeTableStyles={true} // Table styles needed for this page
        />

        {/* Main Content Area */}
        <div className="card mb-3">
          <div className="card-body">
          <h5 className='mb-0 pb-1 pt-1' style={{ fontWeight: 'bold' }}>Part A: Details for each category of staff</h5>
            <div className="row">
              <div className="col-12">
                <div className="table-responsive asi_block_table">
                  <table cellPadding="0" cellSpacing="0" className="table table-bordered block_c_table mb-0">
                    <thead>
                      <tr>
                        <th rowSpan={2}>SL No.</th>
                        <th rowSpan={2}>Category of Staff</th>
                        <th colSpan={3}>Man-days Worked</th>
                        <th rowSpan={2}>Average Number of persons worked</th>
                        <th rowSpan={2}>No. of Mandays paid for</th>
                        <th rowSpan={2}>Wages/salaries (in Rs.)</th>
                      </tr>
                      <tr>
                        <th>Manufacturing mandays worked</th>
                        <th>Non Manufacturing mandays worked</th>
                        <th>Total</th>
                      </tr>
                      <tr>
                        <th>(1)</th>
                        <th>(2)</th>
                        <th>(3)</th>
                        <th>(4)</th>
                        <th>(5)</th>
                        <th>(6)</th>
                        <th>(7)</th>
                        <th>(8)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {labourWagesData.length > 0 ? (
                        (() => {
                          let serialNumber = 0;
                          // Find index where Part B starts
                          const partBIndex = labourWagesData.findIndex(item => 
                            item.categoryOfStaff?.includes('Part B:')
                          );
                          
                          // Filter Part A data only (exclude headers and Part B)
                          const partAData = labourWagesData.filter((item, idx) => {
                            if (partBIndex > 0 && idx >= partBIndex) return false;
                            if (item.categoryOfStaff?.includes('Part A:')) return false;
                            return true;
                          });
                          
                          // Helper function to sum values for specific rows
                          const sumRows = (indices, field) => {
                            let sum = 0;
                            indices.forEach(idx => {
                              if (partAData[idx]) {
                                sum += parseFloat(partAData[idx][field]) || 0;
                              }
                            });
                            return sum > 0 ? sum.toString() : '';
                          };
                          
                          // Get total working days for avgNoPersonsWorked calculation
                          const mfgDaysItem = labourWagesData.find(i => i.categoryOfStaff?.includes('(i) Manufacturing'));
                          const nonMfgDaysItem = labourWagesData.find(i => i.categoryOfStaff?.includes('(ii) Non-manufacturing'));
                          const totalWorkingDays = (parseFloat(mfgDaysItem?.wagesOrSalaries) || 0) + (parseFloat(nonMfgDaysItem?.wagesOrSalaries) || 0);
                          
                          // Helper function to calculate avgNoPersonsWorked sum for specific rows
                          const sumAvgPersonsWorked = (indices) => {
                            if (totalWorkingDays <= 0) return '';
                            let sum = 0;
                            indices.forEach(idx => {
                              if (partAData[idx]) {
                                const mfg = parseFloat(partAData[idx].manufacturing) || 0;
                                const nonMfg = parseFloat(partAData[idx].nonmanufacturing) || 0;
                                const total = mfg + nonMfg;
                                if (total > 0) {
                                  sum += Math.round(total / totalWorkingDays);
                                }
                              }
                            });
                            return sum > 0 ? sum.toString() : '';
                          };
                          
                          return labourWagesData.map((item, originalIndex) => {
                            // Skip header rows
                            const isHeaderRow = item.categoryOfStaff?.includes('Part A:') || 
                                                item.categoryOfStaff?.includes('Part B:') ||
                                                item.categoryOfStaff?.includes('Number of working days');
                            
                            // Skip Part B items (they will be shown in separate card)
                            if (partBIndex > 0 && originalIndex >= partBIndex) return null;
                            
                            if (isHeaderRow) return null;
                            
                            // Increment serial number for each visible row
                            serialNumber++;
                            
                            // Check if row should be bold and auto-calculated
                            const isSubTotal = item.categoryOfStaff?.includes('Sub-Total');
                            const isTotalWorkers = item.categoryOfStaff?.includes('Total Workers');
                            const isTotalEmployees = item.categoryOfStaff?.includes('Total employees');
                            const isUnpaidFamily = item.categoryOfStaff?.includes('Unpaid family');
                            const isBoldRow = isSubTotal || isTotalWorkers || isTotalEmployees;
                            const isAutoCalcRow = isSubTotal || isTotalWorkers || isTotalEmployees;
                            const isDisabledRow = isAutoCalcRow || isUnpaidFamily;
                            
                            // Get auto-calculated values for sum rows
                            const getAutoValue = (field) => {
                              // For avgNoPersonsWorked, use special calculation
                              if (field === 'avgNoPersonsWorked') {
                                if (isSubTotal) {
                                  return sumAvgPersonsWorked([0, 1, 2]);
                                } else if (isTotalWorkers) {
                                  return sumAvgPersonsWorked([0, 1, 2, 4]);
                                } else if (isTotalEmployees) {
                                  return sumAvgPersonsWorked([0, 1, 2, 4, 6, 7, 8]);
                                }
                                return item[field] || '';
                              }
                              
                              // For other fields, use simple sum
                              if (isSubTotal) {
                                // Sub-Total = Row 1 + Row 2 + Row 3 (indices 0, 1, 2 in partAData)
                                return sumRows([0, 1, 2], field);
                              } else if (isTotalWorkers) {
                                // Total Workers (items 4+5) = Sub-Total + Workers through contractors
                                // = (Row 1 + Row 2 + Row 3) + Row 5
                                // = indices 0, 1, 2, 4 in partAData
                                return sumRows([0, 1, 2, 4], field);
                              } else if (isTotalEmployees) {
                                // Total employees (items 6+7+8+9) = Total Workers + Supervisory + Other + Unpaid
                                // = (Row 1 + Row 2 + Row 3 + Row 5) + Row 7 + Row 8 + Row 9
                                // = indices 0, 1, 2, 4, 6, 7, 8 in partAData
                                return sumRows([0, 1, 2, 4, 6, 7, 8], field);
                              }
                              return item[field] || '';
                            };
                          
                          return (
                            <tr key={item.catagoryId || originalIndex}>
                              <td style={{ textAlign: 'center' }}>{serialNumber}</td>
                              <td style={isBoldRow ? { fontWeight: 'bold' } : {}}>{item.categoryOfStaff || ''}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={isAutoCalcRow ? getAutoValue('manufacturing') : (item.manufacturing || '')}
                                  onChange={(e) => handleTableInputChange(originalIndex, 'manufacturing', e.target.value)}
                                  placeholder=""
                                  maxLength="15"
                                  readOnly={isDisabledRow}
                                  disabled={isDisabledRow}
                                  style={{ 
                                    fontSize: '12px', 
                                    textAlign: 'right',
                                    backgroundColor: isDisabledRow ? '#f5f5f5' : '#fff'
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={isAutoCalcRow ? getAutoValue('nonmanufacturing') : (item.nonmanufacturing || '')}
                                  onChange={(e) => handleTableInputChange(originalIndex, 'nonmanufacturing', e.target.value)}
                                  placeholder=""
                                  maxLength="15"
                                  readOnly={isDisabledRow}
                                  disabled={isDisabledRow}
                                  style={{ 
                                    fontSize: '12px', 
                                    textAlign: 'right',
                                    backgroundColor: isDisabledRow ? '#f5f5f5' : '#fff'
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    // Auto calculate: Column 3 (manufacturing) + Column 4 (nonmanufacturing)
                                    (() => {
                                      const mfgVal = isAutoCalcRow ? getAutoValue('manufacturing') : (item.manufacturing || '');
                                      const nonMfgVal = isAutoCalcRow ? getAutoValue('nonmanufacturing') : (item.nonmanufacturing || '');
                                      const mfg = parseFloat(mfgVal) || 0;
                                      const nonMfg = parseFloat(nonMfgVal) || 0;
                                      const sum = mfg + nonMfg;
                                      return sum > 0 ? sum.toString() : '';
                                    })()
                                  }
                                  readOnly
                                  disabled
                                  placeholder=""
                                  maxLength="15"
                                  style={{ 
                                    fontSize: '12px', 
                                    textAlign: 'right',
                                    backgroundColor: '#f5f5f5'
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    // Auto-calculate avgNoPersonsWorked = Total / Number of working days
                                    (() => {
                                      if (isAutoCalcRow) {
                                        return getAutoValue('avgNoPersonsWorked');
                                      }
                                      // For normal rows, show stored value or auto-calculate if working days is available
                                      if (item.avgNoPersonsWorked && item.avgNoPersonsWorked !== '') {
                                        return item.avgNoPersonsWorked;
                                      }
                                      // Auto-calculate only if no manual value and working days available
                                      if (totalWorkingDays > 0 && !isUnpaidFamily) {
                                        const mfgVal = item.manufacturing || '';
                                        const nonMfgVal = item.nonmanufacturing || '';
                                        const mfg = parseFloat(mfgVal) || 0;
                                        const nonMfg = parseFloat(nonMfgVal) || 0;
                                        const total = mfg + nonMfg;
                                        if (total > 0) {
                                          return Math.round(total / totalWorkingDays).toString();
                                        }
                                      }
                                      return '';
                                    })()
                                  }
                                  onChange={(e) => handleTableInputChange(originalIndex, 'avgNoPersonsWorked', e.target.value)}
                                  placeholder=""
                                  maxLength="15"
                                  style={{ 
                                    fontSize: '12px', 
                                    textAlign: 'right'
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={isAutoCalcRow ? getAutoValue('noMandaysPaid') : (item.noMandaysPaid || '')}
                                  onChange={(e) => handleTableInputChange(originalIndex, 'noMandaysPaid', e.target.value)}
                                  placeholder=""
                                  maxLength="15"
                                  readOnly={isDisabledRow}
                                  disabled={isDisabledRow}
                                  style={{ 
                                    fontSize: '12px', 
                                    textAlign: 'right',
                                    backgroundColor: isDisabledRow ? '#f5f5f5' : '#fff'
                                  }}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={isAutoCalcRow ? getAutoValue('wagesOrSalaries') : (item.wagesOrSalaries || '')}
                                  onChange={(e) => handleTableInputChange(originalIndex, 'wagesOrSalaries', e.target.value)}
                                  placeholder=""
                                  maxLength="15"
                                  readOnly={isDisabledRow}
                                  disabled={isDisabledRow}
                                  style={{ 
                                    fontSize: '12px', 
                                    textAlign: 'right',
                                    backgroundColor: isDisabledRow ? '#f5f5f5' : '#fff'
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        });
                        })()
                      ) : (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center' }}>
                            {isLoading ? 'Loading...' : 'No data available'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Part B Card */}
        <div className="card mb-3">
          <div className="card-body">
            <h5 className='mb-0 pb-1 pt-1' style={{ fontWeight: 'bold' }}>Part B: Some details for all categories of staff combined</h5>
            <div className="row">
              <div className="col-12">
                <div className="table-responsive asi_block_table">
                  <table cellPadding="0" cellSpacing="0" className="table table-bordered block_c_table mb-0">
                    <tbody>
                      {labourWagesData.length > 0 ? (
                        (() => {
                          let partBSerialNumber = 10; // Continue from Part A
                          const partBIndex = labourWagesData.findIndex(item => 
                            item.categoryOfStaff?.includes('Part B:')
                          );
                          
                          if (partBIndex < 0) return null;
                          
                          const partBData = labourWagesData.slice(partBIndex);
                          const rows = [];
                          
                          // Find indices for special items
                          const workingDaysIndex = partBData.findIndex(item => 
                            item.categoryOfStaff?.includes('Number of working days')
                          );
                          const manufacturingIndex = partBData.findIndex(item => 
                            item.categoryOfStaff?.includes('(i) Manufacturing')
                          );
                          const nonManufacturingIndex = partBData.findIndex(item => 
                            item.categoryOfStaff?.includes('(ii) Non-manufacturing')
                          );
                          const totalIndex = partBData.findIndex(item => 
                            item.categoryOfStaff?.includes('(iii) Total')
                          );
                          
                          partBData.forEach((item, idx) => {
                            const originalIndex = partBIndex + idx;
                            
                            // Skip Part B header row
                            if (item.categoryOfStaff?.includes('Part B:')) return;
                            
                            // Skip (i), (ii), (iii) items as they will be rendered with "Number of working days"
                            if (item.categoryOfStaff?.includes('(i) Manufacturing') ||
                                item.categoryOfStaff?.includes('(ii) Non-manufacturing') ||
                                item.categoryOfStaff?.includes('(iii) Total')) {
                              return;
                            }
                            
                            partBSerialNumber++;
                            
                            // Special handling for "Number of working days" row
                            if (item.categoryOfStaff?.includes('Number of working days')) {
                              const manufacturingItem = partBData[manufacturingIndex];
                              const nonManufacturingItem = partBData[nonManufacturingIndex];
                              const totalItem = partBData[totalIndex];
                              
                              // Row for (i) Manufacturing days
                              rows.push(
                                <tr key={`working-days-${originalIndex}`}>
                                  <td rowSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle' }}>{partBSerialNumber}</td>
                                  <td rowSpan={3} style={{ verticalAlign: 'middle' }}>{item.categoryOfStaff}</td>
                                  <td>(i) Manufacturing days</td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={manufacturingItem?.wagesOrSalaries || ''}
                                      onChange={(e) => handleTableInputChange(partBIndex + manufacturingIndex, 'wagesOrSalaries', e.target.value)}
                                      onBlur={() => calculateAvgNoPersonsWorked()}
                                      placeholder=""
                                      maxLength="15"
                                      style={{ fontSize: '12px', textAlign: 'right' }}
                                    />
                                  </td>
                                </tr>
                              );
                              // Row for (ii) Non-manufacturing days
                              rows.push(
                                <tr key={`non-manufacturing-${originalIndex}`}>
                                  <td>(ii) Non-manufacturing days</td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={nonManufacturingItem?.wagesOrSalaries || ''}
                                      onChange={(e) => handleTableInputChange(partBIndex + nonManufacturingIndex, 'wagesOrSalaries', e.target.value)}
                                      onBlur={() => calculateAvgNoPersonsWorked()}
                                      placeholder=""
                                      maxLength="15"
                                      style={{ fontSize: '12px', textAlign: 'right' }}
                                    />
                                  </td>
                                </tr>
                              );
                              // Row for (iii) Total - Auto calculate (i) + (ii)
                              const totalWorkingDays = (() => {
                                const mfgDays = parseFloat(manufacturingItem?.wagesOrSalaries) || 0;
                                const nonMfgDays = parseFloat(nonManufacturingItem?.wagesOrSalaries) || 0;
                                const sum = mfgDays + nonMfgDays;
                                return sum > 0 ? sum.toString() : '';
                              })();
                              
                              rows.push(
                                <tr key={`total-working-${originalIndex}`}>
                                  <td>(iii) Total (i+ii)</td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={totalWorkingDays}
                                      readOnly
                                      disabled
                                      placeholder=""
                                      maxLength="15"
                                      style={{ 
                                        fontSize: '12px', 
                                        textAlign: 'right',
                                        backgroundColor: '#f5f5f5'
                                      }}
                                    />
                                  </td>
                                </tr>
                              );
                              return;
                            }
                            
                            // Check if it's "Total cost of Production" - make it bold
                            const isTotalCostRow = item.categoryOfStaff?.includes('Total cost of Production');
                            
                            // Check if row should be disabled (Bonus, Contribution, Workmen welfare, Total cost)
                            const isPartBDisabledRow = item.categoryOfStaff?.includes('Bonus') ||
                                                       item.categoryOfStaff?.includes('Contribution to Provident') ||
                                                       item.categoryOfStaff?.includes('Workmen & staff welfare') ||
                                                       item.categoryOfStaff?.includes('staff welfare expenses') ||
                                                       item.categoryOfStaff?.includes('Total cost of Production');
                            
                            // Normal rows
                            rows.push(
                              <tr key={item.catagoryId || originalIndex}>
                                <td style={{ textAlign: 'center' }}>{partBSerialNumber}</td>
                                <td colSpan={2} style={isTotalCostRow ? { fontWeight: 'bold' } : {}}>{item.categoryOfStaff || ''}</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={item.wagesOrSalaries || ''}
                                    onChange={(e) => handleTableInputChange(originalIndex, 'wagesOrSalaries', e.target.value)}
                                    placeholder=""
                                    maxLength="15"
                                    readOnly={isPartBDisabledRow}
                                    disabled={isPartBDisabledRow}
                                    style={{ 
                                      fontSize: '12px', 
                                      textAlign: 'right',
                                      backgroundColor: isPartBDisabledRow ? '#f5f5f5' : '#fff'
                                    }}
                                  />
                                </td>
                              </tr>
                            );
                          });
                          
                          return rows;
                        })()
                      ) : (
                        <tr>
                          <td colSpan={4} style={{ textAlign: 'center' }}>
                            {isLoading ? 'Loading...' : 'No data available'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div className='card mb-3'>
            <div className='card-header'><h5 className='mb-0 pb-1 pt-1' style={{ fontWeight: 'bold' }}>Control Figures from Profit and Loss</h5></div>
            <div className='card-body'>
             <table className='table table-bordered' style={{minWidth: '100%'}}>
              <thead>
                <tr>
                  <th>SL. No.</th>                 
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {totalProfitandLossAmount.SL_No || totalProfitandLossAmount.Description || totalProfitandLossAmount.Amount ? (
                  <tr>
                    <td>{totalProfitandLossAmount.SL_No || ''}</td>
                    <td>{totalProfitandLossAmount.Description || ''}</td>
                    <td>{totalProfitandLossAmount.Amount || ''}</td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: 'center' }}>
                      {isLoading ? 'Loading...' : 'No data available'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            </div>

          </div>
           {/* Remarks Section */}
           <div className='row'>
            <Remarks 
              remarksData={remarksData} 
              setRemarksData={setRemarksData}
              blockItemData={dropdownItemsData.allItems}
              filteredBlockItems={dropdownItemsData.allItems}
              isLoadingBlockItems={false}
              availableColumns={[3, 4, 5, 6, 7, 8]}
              debouncedBlockItemSearch={() => {}}
              loadMoreBlockItemData={() => {}}
              hasMoreBlockItems={false}
              isLoadingMoreBlockItems={false}
              selectedItemsFromTable={dropdownItemsData.itemNames}
              remarksList={remarksList}
            />
      
        
    </div>
    <style>{`
      .col-md-6.remarks-section {
        width: 100% !important;
      }
    `}</style>

        {/* Action Buttons */}
        {/* <div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button
              type="button"
              className="btn btn_orange mx-1"
            >
              Print
              <i className="fa fa-print ms-1"></i>
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
               onClick={handleSave}
               disabled={isLoading}
            >
               {isLoading ? 'Saving...' : 'Save'}
            </button>
            <button
              type="reset"
              className="btn btn_orange mx-1"
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/profitAndLossAccount')}
            >
              <i className="fa fa-angle-left me-1"></i>
              Previous
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={() => navigate('/input-items')}
            >
              Next
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div> */}

<div className="row">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button 
              type="button" 
              className="btn btn_orange mx-1"
              onClick={() => window.print()}
            >
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button 
              type="button"
              className="btn btn_orange mx-1"
              onClick={handleSave}
            >
              Save
            </button>
          
            <button 
              type="button" 
              className="btn btn_orange mx-1"
              onClick={handleReset}
            >
              Reset
            </button>
            <button 
              type="button" 
              className="btn btn_orange mx-1"
              onClick={() => navigate('/asiScheduleMainMenu')}
            >
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button 
                type="button" 
                className="btn btn_orange mx-1"
                onClick={() => navigate('/profitAndLossAccount')}
              >
                <i className="fa fa-angle-left me-1"></i>
                Previous
            </button>
            <button 
              type="button" 
              className="btn btn_orange mx-1"
              onClick={async () => {
                const saved = await handleSave();
                if (saved) {
                  navigate('/input-items');
                }
              }}
            >
              Next 
              <i className="fa fa-angle-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Remarks Lists Table */}
      <Remarks__list remarksData={filteredRemarksList} />
    </>
  );
}

export default EmploymentAndLabourCost; 